<mat-grid-list class="m-t-16 m-b-16" [cols]="isMobileScreen ? 2 : 3" rowHeight="1:1" gutterSize="8">
    <div id="lightgallery" class="lightgallery">
        <mat-grid-tile *ngFor="let image of galleryImages; let idx = index" class="tile-image" (click)="openGallery(idx)" [style.background-image]="'url(' + sharedService.getImage(image,IMAGE_PROXY_M) + ')'">
        </mat-grid-tile>
    </div>
</mat-grid-list>